import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_LINK } from "@/lib/packages";
import { Instagram, MapPin, Phone, Mail } from "lucide-react";


const LEGAL_LABELS = {
  en: { refund: "Refund Policy", privacy: "Privacy Policy", legal: "Legal" },
  es: { refund: "Política de Reembolso", privacy: "Política de Privacidad", legal: "Legal" },
  pt: { refund: "Política de Reembolso", privacy: "Política de Privacidade", legal: "Legal" },
};

export default function Footer() {
  const { t, lang, setLang } = useLang();
  const legalLabels = LEGAL_LABELS[lang] || LEGAL_LABELS.en;
  return (
    <footer data-testid="site-footer" className="bg-jungle text-sand py-16 md:py-20 border-t border-sand/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-2xl md:text-3xl"><a href="https://paraglidetour.com" className="hover:text-terracotta transition-colors">
            PARAGLIDE<span className="text-terracotta">.</span>TOUR
            </a>
          </div>
          <p className="text-sand/70 mt-4 max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <div className="mt-6 flex gap-3">
            {/**
            <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="btn-ghost" style={{color: "#F7F5F0", borderColor: "rgba(247,245,240,0.4)", padding: "10px 16px", fontSize: "11px"}}>
              WhatsApp
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 border border-sand/30 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors">
              <Instagram size={16} />
            </a>
             */}
             
          </div>
        </div>

        <div>
          <div className="font-overline text-[10px] text-terracotta mb-4">Links</div>
            <ul className="space-y-3 text-sand/80 text-sm">
             <li className="flex items-start gap-2"><a href="https://paraglidetour.com/shop" data-testid="footer-rivas-link" className="hover:text-terracotta transition-colors">{t.footer.shop}</a></li>
            <li className="flex items-start gap-2"><a href="https://paraglidetour.com/destinations" data-testid="footer-costarica-link" className="hover:text-terracotta transition-colors">{t.footer.destinations}</a></li>
            <li className="flex items-start gap-2"><a href="https://paraglidetour.com/media" data-testid="footer-uvita-link" className="hover:text-terracotta transition-colors">{t.footer.media}</a></li>
            <li className="flex items-start gap-2"><a href="https://paraglidetour.com/book" data-testid="footer-huacachina-link" className="hover:text-terracotta transition-colors">{t.footer.book}</a></li>            
            <li className="flex items-start gap-2"><a href="https://paraglidetour.com/gallery" data-testid="footer-caraguatatuba-link" className="hover:text-terracotta transition-colors">{t.footer.photos}</a></li>
           
            </ul>

          
        </div>

        <div>
          <div className="font-overline text-[10px] text-terracotta mb-4">{t.footer.locations}</div>
          <ul className="space-y-3 text-sand/80 text-sm">
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="https://paraglidetour.com/rivas" data-testid="footer-rivas-link" className="hover:text-terracotta transition-colors">Rivas, Pérez Zeledón, CR</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="https://paraglidetour.com/costarica" data-testid="footer-costarica-link" className="hover:text-terracotta transition-colors">Playa Dominicalito, CR</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="https://paraglidetour.com/costarica" data-testid="footer-uvita-link" className="hover:text-terracotta transition-colors">Uvita — Marino Ballena, CR</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="https://paraglidetour.com/peru" data-testid="footer-huacachina-link" className="hover:text-terracotta transition-colors">Huacachina, Peru</a></li>            
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="https://paraglidetour.com/caraguatatuba" data-testid="footer-caraguatatuba-link" className="hover:text-terracotta transition-colors">Litoral Norte SP, BR</a></li>
            {/*<li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="#" data-testid="footer-florianopolis-link" className="hover:text-terracotta transition-colors">Florianópolis, BR</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /><a href="#" data-testid="footer-florianopolis-link" className="hover:text-terracotta transition-colors">Ilha do Mel, BR</a></li>
            */}
          </ul>
        </div>

        <div>
          <div className="font-overline text-[10px] text-terracotta mb-4">{legalLabels.legal}</div>
          <ul className="space-y-3 text-sand/80 text-sm">
            <li>
              <Link
                to="https://paraglidetour.com/refund-policy"
                data-testid="footer-refund-link"
                className="hover:text-terracotta transition-colors"
              >
                {legalLabels.refund}
              </Link>
            </li>
            <li>
              <Link
                to="https://paraglidetour.com/privacy-policy"
                data-testid="footer-privacy-link"
                className="hover:text-terracotta transition-colors"
              >
                {legalLabels.privacy}
              </Link>
            </li>
          
          
           {/*
           <li className="flex items-center gap-2"><Phone size={14} /> +1 814 682 0186</li>
           */} 

            <li className="flex items-center gap-2"><Mail size={14} /> fly@paraglidetour.com</li>

            <li className="flex items-center gap-2">
<Mail size={14} />
            <Link  size={14}
                to="https://paraglidetour.com/contact"
                data-testid="footer-contct-link"
                className="hover:text-terracotta transition-colors">
                  {t.footer.contact}
            </Link>

            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-14 pt-8 border-t border-sand/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-sand/50 text-xs">© {new Date().getFullYear()} ParaglideTour. {t.footer.rights}</div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-sand/50">{t.footer.lang}:</span>
          {["en","es","pt"].map(l => (
            <button
              key={l}
              onClick={() => setLang(l)}
              className={`uppercase tracking-widest px-2 py-1 ${lang === l ? "text-terracotta" : "text-sand/70 hover:text-sand"}`}
            >{l}</button>
          ))}
        </div>
      </div>
    </footer>
  );
}
